import { LabelType } from 'types/graphql';

type LabelGroups = 'ACCOUNTING' | 'INVENTORY' | 'ORDERS';

const LabelTypeGroups: Record<LabelGroups, LabelType[]> = {
  ACCOUNTING: ['INVOICE', 'MANUAL_ADJUSTMENT_ENTRY', 'PAYABLE', 'PAYMENT', 'ADJUSTMENT'],
  INVENTORY: ['INVENTORY_TRANSFER', 'LOT', 'PRODUCTION_RUN'],
  ORDERS: ['SALES_ORDER', 'PURCHASE_ORDER', 'GROWER_PRODUCT', 'BUY_SELL_ORDER'],
} as const;

export default LabelTypeGroups;
